import React from 'react';
import { IconButton, Badge } from '@mui/material';
import { ShoppingCart as ShoppingCartIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CartBadge = () => {
  const navigate = useNavigate();
  const { items } = useSelector((state) => state.ecommerceCart);

  const itemCount = items?.reduce((total, item) => total + item.quantity, 0) || 0;

  return (
    <IconButton
      color="inherit"
      onClick={() => navigate('/shop/cart')}
      aria-label={`Cart with ${itemCount} items`}
    >
      <Badge badgeContent={itemCount} color="error">
        <ShoppingCartIcon />
      </Badge>
    </IconButton>
  );
};

export default CartBadge;
